module.exports = __webpack_public_path__ + "img/plan02_text02.67286b21.png";